export const MENU = [
  { _key: 'home', title: 'Hjem', href: '/' },
  { _key: 'search', title: 'Søk', href: '/sok' },
  { _key: 'about', title: 'Om oss', href: '/om-oss' },
  { _key: 'resources', title: 'Ressurser', href: '/ressurser' },
]
